import React from 'react';
import { CHECKOUT_URL, PURCHASE_ANCHOR } from '../data/content';
interface CTAButtonProps {
  label: string;
  sub?: string;
  target?: 'purchase' | 'checkout';
  className?: string;
}
export function CTAButton({
  label,
  sub,
  target = 'purchase',
  className = ''
}: CTAButtonProps) {
  const isCheckout = target === 'checkout';
  return <a href={isCheckout ? CHECKOUT_URL : PURCHASE_ANCHOR} {...isCheckout ? {
    rel: 'noopener'
  } : {}} className={`block w-full rounded-xl bg-petrol px-5 py-4 text-center font-heading text-base font-extrabold uppercase leading-tight tracking-wide text-white shadow-[0_8px_0_0_#0C2F2A] transition-transform duration-150 ease-out active:translate-y-[3px] active:shadow-[0_5px_0_0_#0C2F2A] hover:-translate-y-[1px] sm:text-lg ${className}`} data-id="element-27" data-mp="2fya4d8chqt3n">
      {label}
      {sub ? <span className="mt-1 block font-body text-[0.7rem] font-medium normal-case tracking-normal text-cream/80" data-id="element-28" data-mp="3cqdnu4oyjqw0">
          {sub}
        </span> : null}
    </a>;
}
export function TrustLine({
  className = ''
}: {
  className?: string;
}) {
  return <p className={`text-center font-heading text-[0.7rem] font-bold uppercase tracking-wide text-petrol/80 sm:text-xs ${className}`} data-id="element-29" data-mp="1d9yk9rbilw73">
      🛡️ 7-Day Money-Back Guarantee <span className="text-gold" data-id="element-30" data-mp="1n8o4vruspur1">•</span> 💙
      Complete 6-in-1 System
    </p>;
}